import { UserInputModel } from '@ail/customers-api'
import { DistributionChannel } from '@ail/notifications-api'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../../../auth/useAuth'
import { PermissionsEnum } from '../../../../../types/enums'
import {
  ChannelSettingKey,
  NotificationChannelsState,
  SETTINGS,
  toggleChannel,
} from './NotificationSettingsUtils'

export function NotificationSettings(props: {
  handleSettingsUpdate: (newSettings: NotificationChannelsState) => void
  userToEdit: UserInputModel
  channels: NotificationChannelsState
}) {
  const { user } = useAuth()
  const { t } = useTranslation('common')
  const { handleSettingsUpdate, userToEdit, channels } = props

  function handleSettingToggle(key: ChannelSettingKey, channel: DistributionChannel) {
    if (!user?.isAdmin) return
    handleSettingsUpdate({ ...channels, [key]: toggleChannel(channels[key], channel) })
  }

  const userPermissions = userToEdit.permissions ?? []
  const isRowDisabled = (requiredPermission: PermissionsEnum | null) =>
    requiredPermission === null || !userPermissions.includes(requiredPermission)
  return (
    <div className="col-12 col-sm-6 col-md-3">
      <div className="box">
        <div className="itemTitle">
          <span>
            <i className="icon-alert"></i>
            {t('NOTIFICATIONS')}
          </span>
        </div>
        <ul className="notif-settings-list">
          {SETTINGS.map(({ key, labelKey, icon, requiredPermission }) => {
            const disabled = isRowDisabled(requiredPermission)
            const active = channels[key]
            return (
              <li key={key} className={`notif-settings-row ${disabled ? 'disabled' : ''}`}>
                <label>
                  <i className={icon}></i>
                  {t(labelKey)}
                </label>
                <div className="input-group">
                  <i
                    className={`icon-alert notif-icon-toggle ${active.includes(DistributionChannel.Native) ? 'active' : ''}`}
                    onClick={() => !disabled && handleSettingToggle(key, DistributionChannel.Native)}
                  ></i>
                  <i
                    className={`icon-mail notif-icon-toggle ${active.includes(DistributionChannel.Email) ? 'active' : ''}`}
                    onClick={() => !disabled && handleSettingToggle(key, DistributionChannel.Email)}
                  ></i>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
